
  if (!customElements.get('scm-guarantee-date')) {
    customElements.define('scm-guarantee-date', class extends HTMLElement {
      connectedCallback() {
        this.updateDate();
        this.timer = window.setInterval(() => this.updateDate(), 60000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      updateDate() {
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Berlin',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).formatToParts(new Date());
        const getPart = type => Number(parts.find(part => part.type === type).value);
        const until = new Date(Date.UTC(getPart('year'), getPart('month') - 1, getPart('day') + 14));
        const date = this.querySelector('[data-guarantee-until]');
        if (!date) return;
        date.dateTime = until.toISOString().slice(0, 10);
        date.textContent = new Intl.DateTimeFormat('de-DE', {
          timeZone: 'UTC',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }).format(until);
      }
    });
  }
